(function () {
  async function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function clearCart() {
    await fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    // wait until Shopify confirms cart is empty
    for (let i = 0; i < 10; i++) {
      const res = await fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const cart = await res.json();
      if (!cart.items || cart.items.length === 0) return;
      await delay(200);
    }
  }

  async function addToCart(form) {
    const formData = new FormData(form);
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    });
    if (!response.ok) throw new Error('Add to cart failed');
    const item = await response.json();

    // confirm product is in the cart before redirecting
    for (let i = 0; i < 10; i++) {
      const cartRes = await fetch('/cart.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const cart = await cartRes.json();
      const found = cart.items.some((c) => c.variant_id === item.variant_id);
      if (found) return item;
      await delay(200);
    }

    throw new Error('Cart not updated in time');
  }

  async function handleAddAndCheckout(form) {
    try {
      // prevent concurrent clicks
      document.body.style.pointerEvents = 'none';
      document.body.style.opacity = '0.6';

      await clearCart();
      await addToCart(form);
      window.location.href = '/checkout';
    } catch (err) {
      console.error('Checkout error:', err);
      alert('Unable to add to cart. Please try again.');
    } finally {
      document.body.style.pointerEvents = '';
      document.body.style.opacity = '';
    }
  }

  function attachToProductForms() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (form.__redirectBound) return;
      form.__redirectBound = true;

      form.addEventListener(
        'submit',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation(); // stop Shopify’s script
          handleAddAndCheckout(form);
        },
        true
      );
    });
  }

  function attachToQuickAddButtons() {
    document.body.addEventListener(
      'click',
      function (e) {
        const btn = e.target.closest(
          '[data-add-to-cart],[data-ajax-add-to-cart],[data-product-atc]'
        );
        if (!btn) return;
        e.preventDefault();
        e.stopImmediatePropagation();

        const form = btn.closest('form[action*="/cart/add"]');
        if (form) handleAddAndCheckout(form);
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    attachToProductForms();
    attachToQuickAddButtons();

    document.addEventListener('shopify:section:load', attachToProductForms);
  });
})();
